import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Button,
  Link
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { commonService } from "../../../../services/common.service";
import "./_promotions.css";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import  Close from "@material-ui/icons/Close";
import { Dialog, DialogContent, DialogActions ,DialogTitle} from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  titleStyle: {
    textTransform: "Uppercase",
    color: theme.palette.ePrimary?.base,
    lineHeight: "1.2",
    marginBottom: "2%",
  },
  subTitle: {
    color: theme.palette.eSecondary?.base,
    lineHeight: "1",
    fontSize:'1rem'+'!important'
  },
  promotionDescription: {
    marginTop: "1%",
    marginBottom:"0% !important"
  },
  cardStyle: {
    height: "100%",
    borderRadius: "5px !important",
    backgroundColor: theme.palette.whiteColor.main,
  },
  linkStyle: {
    cursor: "pointer",
    color: theme.palette.ePrimary?.base +"!important",
    textDecoration:"underline !important",
    fontSize: "0.75rem",
    fontWeight:"500"
  },
  imgStyle: {
    height: "47%",
    width: "50%",
    objectFit: "contain",
    float: "right",
    marginTop: "0.4%",
  },
  content: {
    padding: "3% 4% 1% 4% !important",
    height: "82%",
  },
  buttonDiv: {
    display: "flex",
    ['@media (min-width:1025px)']: {
      width: "100%",
      marginBottom: "0 !important"
    },
    marginBottom: "0.7rem"
  },
  descriptionMargin: {
    ['@media (min-width:1025px)']: {
      marginBottom: "0% !important"
    }
  },
  dialogTitle:{
    color:theme.palette.eWhite?.base,
    backgroundColor:theme.palette.ePrimary?.base,
  },
  crossButton:{
      color: theme.palette.eWhite?.base,
      position: 'absolute',
      right:8,
      top:15
  },
  titleFont:{
    fontSize:"1rem",
    marginRight : '5rem'
  },
  submitButton:{
    backgroundColor:theme.palette.ePrimary?.base,
    color:theme.palette.eWhite?.base,
    borderRadius:30,
    fontSize:"0.875rem",
    '&:hover': {
      backgroundColor: theme.palette.ePrimary?.hover,
    },
    padding: "1% 8%",
  },
  justify:{
    textAlign: 'justify'
  }
}));
export default function EPromotionsCard({ item }) {
  const classes = useStyle();
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const [open, setOpen] = useState(false);
  const [imgCode, setImage] = useState();
  const {t:labels, ready: labelReady} = useTranslation("label-E_PROMOTIONS");
  useEffect(() => {
    if (item?.ContentIconName) {
      commonService
        .getAssestUrl(item?.ContentIconName)
        .then((response) => {
          setImage(response);
        })
        .catch((err) => {
          setImage(null);
        });
    }
  }, [item]);
  const handleClose = () => {
    setOpen(false);
  }; const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <Card className={classes.cardStyle}>
      <CardContent
        className={`${classes.content}`}
        style={open ? {overflowY: browserName === "firefox" ? "auto" : "overlay"} : null}
      >
      {/* {
        labelReady ?
        <Typography variant="h6" align="left" className={classes.titleStyle}>
          <b>{labels("E_PROMOTIONS_HEADING")}</b>
        </Typography>
        : <Skeleton />
      } */}

        <Typography variant="subtitle1" align="left" className={classes.subTitle}>
          <b>{item?.AnnouncementTitle}</b>
        </Typography>
        {imgCode ? (<>
          <img
            src={imgCode?.assetPath}
            className={classes.imgStyle}
          /></>):null}
         <Typography
            variant="subtitle2"
            className={
                 `PromotionDesc ${classes.promotionDescription} ${classes.descriptionMargin}`
            }
            dangerouslySetInnerHTML={{
              __html: 
              item?.AnnouncementDescription.slice(0,60)+"..."
            }}
          >
            </Typography>
            {
              labelReady ?
            <Link
              className={classes.linkStyle}
              onClick={() => {
                handleClickOpen(item)
              }}
            >
               {labels("E_PROMOTIONS_READ_MORE")}
            </Link>
            : <Skeleton />
            }
             <Dialog onClose={handleClose} open={open}>
              <DialogTitle className={classes.dialogTitle}>
                  <Typography variant="subtitle1" align="left" className={classes.titleFont}>
                    <b>{item?.AnnouncementTitle}</b>
                  </Typography><Button startIcon={<Close />} onClick={handleClose} className={classes.crossButton}></Button>
              </DialogTitle>
              <DialogContent dividers>
                          <img
                        src={imgCode?.assetPath}
                        className={classes.imgStyle}
                      />
                    <Typography
                        variant="subtitle2"
                        className={
                          `readmoreDescription ${classes.promotionDescription} ${classes.justify}`
                        }
                        dangerouslySetInnerHTML={{
                          __html:   
                          item?.AnnouncementDescription
                        }}
                      >
                        </Typography>
              </DialogContent>
              <DialogActions>
              <Button autoFocus onClick={handleClose} className={classes.submitButton}>
              {labelReady ? (<>{labels("E_PROMOTIONS_DIALOG_OK")}</>) : <Skeleton />}
                         </Button>
              </DialogActions>
              </Dialog>
  
        </CardContent>
     </Card>
  );
}
